// Un request del bloque de entrega del carrito (modo, dirección, propina): devuelve el stream, nada con un
// 2xx vacío, visita el login si la sesión venció y lanza con lo demás. Doc: _docs/features/cart/cart_show.md
export const DELIVERY_ERROR = "No se pudo actualizar la entrega. Intenta de nuevo."

// JSON con Accept turbo-stream; el CSRF solo si la página trae el meta (con la protección apagada no está)
export async function deliveryRequest(url, body, { method = "POST", visit } = {}) {
  const token = document.querySelector("meta[name='csrf-token']")?.content
  const response = await fetch(url, {
    method,
    headers: { "Content-Type": "application/json", Accept: "text/vnd.turbo-stream.html", ...(token ? { "X-CSRF-Token": token } : {}) },
    body: JSON.stringify(body)
  })
  if (response.headers.get("Content-Type")?.includes("turbo-stream")) return response.text()
  if (response.redirected) { visit?.(response.url); return null }
  if (response.ok) return null
  throw new Error(`HTTP ${response.status}`)
}
